import React, { useState, useEffect } from "react";
import MovieCard from "./MovieCard";
import Pagination from "./Pagination";

const MovieList = ({ movies }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [moviesPerPage] = useState(15); // Mostrar 15 películas por página
  
  // Reiniciar a la primera página cuando cambia la lista de películas
  useEffect(() => {
    setCurrentPage(1);
  }, [movies]);
  
  // Calcular índices para la paginación
  const indexOfLastMovie = currentPage * moviesPerPage;
  const indexOfFirstMovie = indexOfLastMovie - moviesPerPage;
  const currentMovies = movies.slice(indexOfFirstMovie, indexOfLastMovie);
  
  // Calcular el número total de páginas
  const totalPages = Math.ceil(movies.length / moviesPerPage);
  
  // Manejar el cambio de página
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    // Hacer scroll hacia arriba cuando se cambia de página
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="p-1 m-4 text-white bg-black">
      <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5">
        {currentMovies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
      
      {/* Mostrar paginación solo si hay más de una página */}
      {totalPages > 1 && (
        <div className="mt-6 mb-8">
          <Pagination 
            currentPage={currentPage} 
            totalPages={totalPages} 
            onPageChange={handlePageChange} 
          />
        </div>
      )}
    </div>
  );
};

export default MovieList;
